import { Stack, Typography } from '@mui/material';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { CompletenesItemProps as Props } from './types';

export const CompletenesItem = memo(
  ({ className, item, isPeople, isLast }: Props) => {
    const { name, score } = item;

    return (
      <Styled.Wrapper
        className={classnames('CompletenesItem', className)}
        sx={SX.root(isLast)}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack direction="row" alignItems="center" gap={0.5}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={SX.iconWrapper}
          >
            <Icon
              name={isPeople ? 'people' : 'business'}
              size={12}
              sxx={SX.icon(isPeople)}
            />
          </Stack>
          <Typography sx={SX.name}>{name}</Typography>
        </Stack>
        <Typography sx={SX.score}>{score}</Typography>
      </Styled.Wrapper>
    );
  }
);

CompletenesItem.displayName = 'CompletenesItem';
